import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const generalStore = create(
  persist(
    (set, get) => ({
      showError: false,
      projectModalOpen: false,
      roleModalOpen: false,
      selectedProject: null,
      selectedRole: null,
      selectedProjectSfdcId: null,
      vmAccessToken: null,
      customerSearch: [],
      projectListData: [],
      deleteModalOpen: false,
      editModalOpen: false,
      dynamicConfirmationModel: false,
      drawerState: {
        top: false,
        left: false,
        bottom: false,
        right: false,
      },
      customerDrawerState: {
        top: false,
        left: false,
        bottom: false,
        right: false,
      },
      drawerCustId: null,
      drawerCustDetails: null,
      changePasswordModal: false,
      logoutLoader: false,
      verifyBookingAndFormLoader: false,
      filters: null,
      applyFilters: false,
      userRole: [],

      setUserRole: (payload) => {
        set((state) => ({
          ...state,
          userRole: payload,
        }));
      },
      setChangePasswordModal: (payload) => {
        set((state) => ({
          ...state,
          changePasswordModal: payload,
        }));
      },
      setShowError: (payload) => {
        set((state) => ({
          ...state,
          showError: payload,
        }));
      },
      setDrawerCustId: (payload) => {
        set((state) => ({
          ...state,
          drawerCustId: payload,
        }));
      },
      setDrawerCustDetails: (payload) => {
        set((state) => ({
          ...state,
          drawerCustDetails: payload,
        }));
      },
      setDeleteModalOpen: (payload) => {
        set((state) => ({
          ...state,
          deleteModalOpen: payload,
        }));
      },
      setEditModalOpen: (payload) => {
        set((state) => ({
          ...state,
          editModalOpen: payload,
        }));
      },
      setProjectModalOpen: (payload) => {
        set((state) => ({
          ...state,
          projectModalOpen: payload,
        }));
      },
      setRoleModalOpen: (payload) => {
        set((state) => ({
          ...state,
          roleModalOpen: payload,
        }));
      },
      setSelectedRole: (payload) => {
        set((state) => ({
          ...state,
          selectedRole: payload,
        }));
      },
      setProjectListData: (payload) => {
        set((state) => ({
          ...state,
          projectListData: payload,
        }));
      },
      setSelectedProject: (payload) => {
        set((state) => ({
          ...state,
          selectedProject: payload,
        }));
      },
      setSelectedProjectSfdcId: (payload) => {
        set((state) => ({
          ...state,
          selectedProjectSfdcId: payload,
        }));
      },
      setVmAccessToken: (payload) => {
        set((state) => ({
          ...state,
          vmAccessToken: payload,
        }));
      },
      setCustomerSearch: (payload) => {
        set((state) => ({
          ...state,
          customerSearch: payload,
        }));
      },
      setDynamicConfirmationModel: (payload) => {
        set((state) => ({
          ...state,
          dynamicConfirmationModel: payload,
        }));
      },
      setDrawerState: (payload) => {
        set((state) => ({
          ...state,
          drawerState: payload,
        }));
      },
      setCustomerDrawerState: (payload) => {
        set((state) => ({
          ...state,
          customerDrawerState: payload,
        }));
      },
      setLogoutLoader: (payload) => {
        set((state) => ({
          ...state,
          logoutLoader: payload,
        }));
      },
      setVerifyBookingAndFormLoader: (payload) => {
        set((state) => ({
          ...state,
          verifyBookingAndFormLoader: payload,
        }));
      },
      setFilters: (payload) => {
        set((state) => ({
          ...state,
          filters: payload,
        }));
      },
      setApplyFilters: (payload) => {
        set((state) => ({
          ...state,
          applyFilters: payload,
        }));
      },
    }),
    {
      name: "generalStore",
      partialize: (state) => ({
        selectedProject: state.selectedProject,
        selectedProjectSfdcId: state.selectedProjectSfdcId,
        vmAccessToken: state.vmAccessToken,
      }),
      storage: createJSONStorage(() => sessionStorage),
    }
  )
);

// import { create } from "zustand";
// import { getFromStorage } from "utils/storage";

// export const generalStore = create((set, get) => ({
//   showError:false,
//   projectModalOpen: false,
//   selectedProject: null,
//   customerSearch: [],
//   projectListData: [],
//   deleteModalOpen: false,
//   dynamicConfirmationModel: false,
//   drawerState: {
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   },
//   customerDrawerState: {
//     top: false,
//     left: false,
//     bottom: false,
//     right: false,
//   },
//   drawerCustId: null,
//   drawerCustDetails: null,
//   // schemeList:null,

//   setShowError: (payload) => {
//     set((state) => ({
//       showError: payload,
//     }));
//   },
//   setDrawerCustId: (payload) => {
//     set((state) => ({
//       drawerCustId: payload,
//     }));
//   },
//   setDrawerCustDetails: (payload) => {
//     set((state) => ({
//       drawerCustDetails: payload,
//     }));
//   },
//   setDeleteModalOpen: (payload) => {
//     set((state) => ({
//       deleteModalOpen: payload,
//     }));
//   },
//   setProjectModalOpen: (payload) => {
//     set((state) => ({
//       projectModalOpen: payload,
//     }));
//   },
//   setProjectListData: (payload) => {
//     set((state) => ({
//       projectListData: payload,
//     }));
//   },
//   setSelectedProject: (payload) => {
//     set((state) => ({
//       selectedProject: payload,
//     }));
//   },
//   setCustomerSearch: (payload) => {
//     set((state) => ({
//       customerSearch: payload,
//     }));
//   },
//   setDynamicConfirmationModel: (payload) => {
//     set((state) => ({
//       dynamicConfirmationModel: payload,
//     }));
//   },

//   setDrawerState: (payload) => {
//     set((state) => ({
//       drawerState: payload,
//     }));
//   },
//   setCustomerDrawerState: (payload) => {
//     set((state) => ({
//       customerDrawerState: payload,
//     }));
//   },
//   // setSchemeList: (payload) => {
//   //   set((state) => ({
//   //     schemeList: payload,
//   //   }));
//   // },
// }));

// import { getFromStorage } from "utils/storage";
// import { create } from "zustand";
// import { persist, createJSONStorage } from "zustand/middleware";
// export const generalStore = create(
//   persist(
//     (set, get) => ({
//       showError: false,
//       projectModalOpen: false,
//       selectedProject: null,
//       customerSearch: [],
//       projectListData: [],
//       deleteModalOpen: false,
//       dynamicConfirmationModel: false,
//       drawerState: {
//         top: false,
//         left: false,
//         bottom: false,
//         right: false,
//       },
//       customerDrawerState: {
//         top: false,
//         left: false,
//         bottom: false,
//         right: false,
//       },
//       drawerCustId: null,
//       drawerCustDetails: null,
//       // schemeList:null,

//       setShowError: (payload) => {
//         set((state) => ({
//           showError: payload,
//         }));
//       },
//       setDrawerCustId: (payload) => {
//         set((state) => ({
//           drawerCustId: payload,
//         }));
//       },
//       setDrawerCustDetails: (payload) => {
//         set((state) => ({
//           drawerCustDetails: payload,
//         }));
//       },
//       setDeleteModalOpen: (payload) => {
//         set((state) => ({
//           deleteModalOpen: payload,
//         }));
//       },
//       setProjectModalOpen: (payload) => {
//         set((state) => ({
//           projectModalOpen: payload,
//         }));
//       },
//       setProjectListData: (payload) => {
//         set((state) => ({
//           projectListData: payload,
//         }));
//       },
//       setSelectedProject: (payload) => {
//         set((state) => ({
//           selectedProject: payload,
//         }));
//       },
//       setCustomerSearch: (payload) => {
//         set((state) => ({
//           customerSearch: payload,
//         }));
//       },
//       setDynamicConfirmationModel: (payload) => {
//         set((state) => ({
//           dynamicConfirmationModel: payload,
//         }));
//       },

//       setDrawerState: (payload) => {
//         set((state) => ({
//           drawerState: payload,
//         }));
//       },
//       setCustomerDrawerState: (payload) => {
//         set((state) => ({
//           customerDrawerState: payload,
//         }));
//       },
//       // setSchemeList: (payload) => {
//       //   set((state) => ({
//       //     schemeList: payload,
//       //   }));
//       // },
//     }),
//     {
//       name: "generalStore",
//       partialize: (state) => ({ selectedProject: state.selectedProject }),
//       storage: createJSONStorage(() => localStorage),
//     }
//   )
// );
